<script>
export default {
    name: 'BaseStatistic',
    data () {
        return {
            searchErrorMessageKey: '',
            detailKey: 'StatisticDetail',
            dataTable: [],
            keySearch: '',
            pagination: {
                page: 1,
                rowsPerPage: 10
            },
            updating: false,
            fireUpdate: false,
            loadingTimeout: null,
            loadingDelay: 500
        }
    },
    methods: {
        getSearchPromise () {
            // to be implemented by inheritor
        },
        search () {
            if (this.updating) {
                this.fireUpdate = true
                return
            }
            this.updating = true
            this.loadingTimeout = setTimeout(this.$appService.showLoading, this.loadingDelay)
            this.getSearchPromise().then(
                result => {
                    this.pagination.totalItems = result.data.count
                    this.dataTable = result.data.results
                },
                this.$appService.handleRequestError(this.$t(this.searchErrorMessageKey))
            ).finally(() => {
                this.updating = false
                clearTimeout(this.loadingTimeout)
                if (this.fireUpdate) {
                    this.fireUpdate = false
                    this.search()
                    return
                }
                this.$appService.hideLoading()
            })
        },
        select (item) {
            if (this.$refs[this.detailKey]) {
                this.$refs[this.detailKey].open(item)
            } else {
                console.error('Cannot found item with ref: ' + this.detailKey)
            }
        }
    },
    watch: {
        keySearch () {
            this.pagination.page = 1
            this.search()
        },
        pagination () {
            this.search()
        }
    }
}
</script>
<style scoped lang="scss">
    table {
        text-align: left;

        th, td {
            padding: 5px;
        }
    }
</style>
